import { FC, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRole } from 'hooks/useRole'
import { isManagerAllowedPath } from 'handlers/isManagerAllowedPath'

/**
 * Редирект менеджера с запрещённых разделов на таблицу заказов.
 */
const ManagerRouteGuard: FC = () => {
  const { isManager } = useRole()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isManager && !isManagerAllowedPath(location?.pathname ?? '')) {
      navigate('/', { replace: true })
    }
  }, [isManager, location?.pathname, navigate])

  return null
}

export default ManagerRouteGuard
